import React from 'react';
import InputLinkWire from 'data/components/ProductModal/components/ProductModalTabs/SettingsTab/components/inputs/InputLinkWire';

export default function InputLinkRelay({ product }) {
    return <InputLinkWire product={product} />;
}
